module.exports = __webpack_public_path__ + "static/img/20220610_03.8e82a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220610_03.png
// module id = UfQN
// module chunks = 0